'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HairStories = function () {
  function HairStories(el) {
    (0, _classCallCheck3.default)(this, HairStories);

    this.classes = {
      imageContainer: 'js-HairStories_ImageContainer',
      imageTrack: 'js-HairStories_ImageTrack',
      bottomedOutImageContainer: 'js-HairStories_ImageContainer-bottomedOut',
      fixedImageContainer: 'js-HairStories_ImageContainer-fixed',
      hiddenImageContainer: 'js-HairStories_ImageContainer-hidden',
      section: 'js-HairStories_Fixed'
    };

    this.els = {
      el: el,
      fixedSections: (0, _functional.getElements)('.' + this.classes.section)
    };

    this._activeFixedGroup = null;
    this.fixedGroups = this.setupFixedGroups();
    this.absoluteTriggerPoints = this.findAbsoluteTriggerPoints();

    this.isTicking = false;
    this.lastKnownY = window.scrollY;
    this.scrollDirection = null;

    this.onScroll = this.onScroll.bind(this);
    this.updateEl = this.updateEl.bind(this);

    this.setupListeners();
  }

  (0, _createClass3.default)(HairStories, [{
    key: 'setupListeners',
    value: function setupListeners() {
      window.addEventListener('scroll', this.onScroll);
    }
  }, {
    key: 'onScroll',
    value: function onScroll() {
      var previouslyKnown = this.lastKnownY;

      this.lastKnownY = window.scrollY;
      this.scrollDirection = previouslyKnown < this.lastKnownY ? 'down' : 'up';

      this.requestTick();
    }
  }, {
    key: 'requestTick',
    value: function requestTick() {
      if (!this.isTicking) window.requestAnimationFrame(this.updateEl);

      // If a rAF is already queued we don't want to call another one
      this.isTicking = true;
    }
  }, {
    key: 'updateEl',
    value: function updateEl() {
      // Reset the tick so we can capture the next onScroll
      this.isTicking = false;

      // this.activeFixedGroup = this.findActiveFixedGroupIndex()
    }
  }, {
    key: 'findActiveFixedGroupIndex',
    value: function findActiveFixedGroupIndex() {
      var _this = this;

      return [].concat((0, _toConsumableArray3.default)(this.fixedGroups)).findIndex(function (group) {
        return _this.lastKnownY >= group.triggerPoints.start && _this.lastKnownY <= group.triggerPoints.end;
      });
    }
  }, {
    key: 'setupFixedGroups',
    value: function setupFixedGroups() {
      var _this2 = this;

      return this.els.fixedSections.map(function (section) {
        if (section.dataset.hasBeenProcessed === 'true') return;

        var _section$dataset = section.dataset,
            wantedColumn = _section$dataset.moduleFixedColumn,
            wantedImage = _section$dataset.moduleFixedImage;

        var connectedSections = _this2.findConnectedSections(section, wantedColumn, wantedImage, [section]);

        return {
          wantedColumn: wantedColumn,
          wantedImage: wantedImage,
          sectionElements: connectedSections
        };
      }).filter(function (connectedSection) {
        return connectedSection && connectedSection.sectionElements.length > 1;
      }).map(function (group) {
        var startImage = (0, _functional.getElement)('.' + _this2.classes.imageContainer + '[data-module-image-id=\'' + group.wantedImage + '\'][data-module-image-column=\'' + group.wantedColumn + '\']', { context: group.sectionElements[0] });
        var startTriggerPoint = (0, _utils.getOffsetTop)(startImage);

        var endImage = (0, _functional.getElement)('.' + _this2.classes.imageContainer + '[data-module-image-id=\'' + group.wantedImage + '\'][data-module-image-column=\'' + group.wantedColumn + '\']', { context: group.sectionElements[group.sectionElements.length - 1] });
        var endTriggerPoint = (0, _utils.getOffsetTop)(endImage);

        var triggerPoints = {
          start: startTriggerPoint,
          end: endTriggerPoint
        };

        var imageTrack = (0, _functional.getElement)('.' + _this2.classes.imageContainer + '[data-module-image-id=\'' + group.wantedImage + '\'][data-module-image-column=\'' + group.wantedColumn + '\']', { context: group.sectionElements[0] }).closest('.' + _this2.classes.imageTrack);
        imageTrack.style.height = 100 * group.sectionElements.length + 'vh';

        // Finally hide all but the first image container
        group.sectionElements.forEach(function (section, index) {
          if (index === 0) return;

          var imageContainer = (0, _functional.getElement)('.' + _this2.classes.imageContainer + '[data-module-image-id=\'' + group.wantedImage + '\'][data-module-image-column=\'' + group.wantedColumn + '\']', { context: section });
          imageContainer.classList.add(_this2.classes.hiddenImageContainer);
        });

        return {
          triggerPoints: triggerPoints,
          sectionElements: group.sectionElements,
          imageContainer: startImage
        };
      });

      /*
      For each section we need to see if it's already been processed, if it has, skip it.
      If not we need to jump to the next section to see if this contains an image with the same id in the same column
        ? if so this becomes part of the group
        : if not we start the process again and create a new group
       */
    }
  }, {
    key: 'findConnectedSections',
    value: function findConnectedSections(section, wantedColumn, wantedImage, sections) {
      var nextSection = section.nextElementSibling;
      var wantedImageContainerNode = (0, _functional.getElement)('.' + this.classes.imageContainer + '[data-module-image-id=\'' + wantedImage + '\'][data-module-image-column=\'' + wantedColumn + '\']', { context: nextSection });

      if (wantedImageContainerNode) {
        sections.push(nextSection);

        section.dataset.hasBeenProcessed = 'true';

        this.findConnectedSections(nextSection, wantedColumn, wantedImage, sections);
      }

      return sections;
    }
  }, {
    key: 'findAbsoluteTriggerPoints',
    value: function findAbsoluteTriggerPoints() {
      return {
        start: this.fixedGroups[0].triggerPoints.start,
        end: this.fixedGroups[this.fixedGroups.length - 1].end
      };
    }
  }, {
    key: 'activeFixedGroup',
    get: function get() {
      return this._activeFixedGroup;
    },
    set: function set(val) {
      var _this3 = this;

      this._activeFixedGroup = val;

      this.fixedGroups.forEach(function (group, index) {
        group.imageContainer.classList.toggle(_this3.classes.fixedImageContainer, index === val);
      });

      if (val === -1) {
        if (this.lastKnownY < this.absoluteTriggerPoints.start) {
          // We are before fixed starts
        } else if (this.lastKnownY > this.absoluteTriggerPoints.end) {
          // We are after fixed has finished
        }
      }
    }
  }]);
  return HairStories;
}();

exports.default = HairStories;